export const generateRandomId = () => {
  const id = Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '')
    .substring(2, 10)

  return ['mecl', id].join('-')
}
